const dimensions = {
  headerMobileHeight: 157,
  headerHeight: 185,
  mobileMaxWidth: 699,
  tabletMaxWidth: 999,
  desktopMaxWidth: 1199,
  boxMobileMargin: 16,
  boxMargin: 24,
}

const palette = {
  text: '#4C4C4C',
  disabled: '#D4D4D4',
  textPlaceholder: '#9D9D9D',
  textError: '#EB4B4E',
  textSuccess: '#28B546',
  divider: '#E6E6E6',
}

const paletteDark = {
  text: '#f7f7f7',
  disabled: '#757575',
  textSecondary: '#B5B5B5',
  textError: '#EB4B4E',
  textSuccess: '#28B546',
  divider: '#4A4A4A',
}

export default {
  dimensions,
  mediaQueries: {
    phonePortrait: `@media (max-width: ${dimensions.mobileMaxWidth + 1}px)`,
    phonePortraitLarge: `@media (min-width: 480px) and (max-width: ${dimensions.mobileMaxWidth + 1}px)`,
    tabletPortrait: `@media (min-width: ${dimensions.mobileMaxWidth + 1}px)`,
    tabletLandscape: `@media (min-width: ${dimensions.tabletMaxWidth + 1}px)`,
    desktop: `@media (min-width: ${dimensions.desktopMaxWidth + 1}px)`,
    bigHeight: `@media (min-width: ${dimensions.mobileMaxWidth + 1}px) and (min-height: 1080px)`
  },
  zIndices: {
    pageBackground: 1,
    pageLayer: 2,
    mainContainer: 3,
    header: 10,
    pageContent: 5,
    fixedNav: 50,
    popin: 100,
    previewBaneer: 200,
    previewExpired: 201,
    console: 5000,
  },
  colors: {
    textDefault: palette.text,
    titleColor: palette.text,
    textSecondary: palette.textPlaceholder,
    mainBackground: '#fff',
    selfcareContentBackground: '#f7f7f7',
    mainShadow: '0 0 24px 0 rgba(0, 0, 0, .2)',
    contentBoxShadow: '0 2px 4px 0 rgba(0, 0, 0, .12)',
    headerShadow: '0 -2px 6px 0 rgba(0, 0, 0, .5)',
    boxBorder: '#c1c1c1',
    boxIcon: '#dbdbdb',
    boxSeparator: '#f4f4f4',
    inputBackground: '#FFF',
    errorBackground: '#f5e7e7',
    success: '#169700',
    fail: '#DB2525',
    buttonText: '#FFF',
    notificationSuccess: '#28B546',
    notificationSuccessLight: '#F0FAF1',
    notificationError: '#EB4B4E',
    notificationErrorLight: '#FFE6E6',

    ...palette,

    darkTheme: {
      textDefault: paletteDark.text,
      titleColor: paletteDark.text,
      textSecondary: palette.textPlaceholder,
      mainBackground: 'rgba(10, 10, 10, .87)',
      boxBorder: paletteDark.text,
      inputBackground: 'transparent',
      ...paletteDark,
    }
  }
}
